export enum SubscriptionStatus {
  STATUS_ACTIVE = 'active',
  STATUS_CANCELED = 'canceled',
  STATUS_INACTIVE = 'inactive',
  STATUS_INCOMPLETE = 'incomplete',
  STATUS_TRIAL = 'trial',
}
